import { render } from "./Vip.vue?vue&type=template&id=0397f745&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"

import "./Vip.vue?vue&type=style&index=0&id=0397f745&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0397f745"]])

export default __exports__